import { Modal } from "antd";
import type { ReactNode } from "react";
import type { PageThemeTokens } from "./theme/types";
import "./styles/v2Modal.css";

export interface OpenV2ConfirmModalOptions {
  tokens: PageThemeTokens;
  title: ReactNode;
  content: ReactNode;
  okText: ReactNode;
  cancelText: ReactNode;
  onOk: () => void | Promise<void>;
}

/** V2 主题化确认弹窗 — 用于关闭会话等操作 */
export function openV2ConfirmModal({
  tokens,
  title,
  content,
  okText,
  cancelText,
  onOk,
}: OpenV2ConfirmModalOptions) {
  const isDark = tokens.appearance === "dark";

  Modal.confirm({
    title,
    content,
    okText,
    cancelText,
    onOk,
    centered: true,
    width: 300,
    icon: null,
    closable: false,
    className: "uchat-v2-confirm-modal",
    styles: {
      mask: {
        background: isDark ? "rgba(0, 0, 0, 0.78)" : "rgba(0, 0, 0, 0.5)",
        backdropFilter: "blur(4px)",
      },
      content: {
        backgroundColor: tokens.messageBg,
        border: `1px solid ${
          isDark ? "rgba(255, 255, 255, 0.08)" : tokens.border
        }`,
        borderRadius: 16,
        boxShadow: isDark
          ? "0 20px 48px rgba(0, 0, 0, 0.55), inset 0 1px 0 rgba(255, 255, 255, 0.06)"
          : `0 16px 40px ${tokens.shadow}`,
        padding: "28px 22px 22px",
        ["--uchat-v2-modal-text" as string]: tokens.text,
        ["--uchat-v2-modal-text-secondary" as string]: tokens.textSecondary,
        ["--uchat-v2-modal-surface" as string]: tokens.hoverBg,
        ["--uchat-v2-modal-ok-text" as string]: tokens.chatUserMessageText,
        ["--uchat-v2-confirm-ok-bg" as string]: `linear-gradient(180deg, ${tokens.chatUserGradientStart} 0%, ${tokens.chatUserGradientEnd} 100%)`,
      },
      body: {
        padding: 0,
      },
      header: {
        background: "transparent",
        marginBottom: 0,
      },
      footer: {
        marginTop: 0,
      },
    },
    okButtonProps: {
      className: "uchat-v2-confirm-ok",
      type: "default",
    },
    cancelButtonProps: {
      className: "uchat-v2-confirm-cancel",
      type: "default",
    },
  });
}
